import { Directive } from '@angular/core';
import { getCountryName } from 'src/app/_helpers/nationalities';
import { getBooleanLabel } from 'src/app/_helpers/utils';
import { BaseBusinessInsuranceMetadata } from 'src/app/_types/lead.types';

import { BaseMetadataComponent } from '../../base-metadata.component';

@Directive()
export abstract class SharedBusinessMetadataComponentAbstract extends BaseMetadataComponent<BaseBusinessInsuranceMetadata> {
  getBooleanLabel = getBooleanLabel;

  getActivityCountriesText(countryCodes?: string[]): string {
    if (!countryCodes?.length) return '';
    return countryCodes
      .map((code) => getCountryName(code, 'fr') || code)
      .join(', ');
  }
}
